import { Channel } from 'app/constants';
import { PartnerMapOperator } from 'app/enum';
import { RestfulModel, Store } from 'app/model';
import { Brand } from 'app/model/cris/brand';
import { ModelWithoutId } from 'app/type';

export interface PartnerMapQuery extends RestfulModel<number> {
    channel?: Channel;
    persistentBrand?: Brand;
    persistentStore?: Store;
    operator: PartnerMapOperator;
    modifierType: string;
    modifierBrands: Brand[];
    modifierStores: Store[];
    remarks?: string;
}

export const createPartnerMapQuery = (): ModelWithoutId<PartnerMapQuery> => ({
    operator: PartnerMapOperator.ONLY,
    modifierBrands: [],
    modifierStores: [],
    modifierType: 'BRAND',
});
